import { sqliteTable, text, real, integer } from "drizzle-orm/sqlite-core";
import { fleetVehicles } from "./vehicles";
import { vehicleYards } from "./vehicle-yards";

// ============================================================================
// vehicle_transfers — บันทึกการโอนย้ายรถระหว่างลาน
// ============================================================================
export const vehicleTransfers = sqliteTable("fleet_vehicle_transfers", {
  id: text("id").primaryKey(),
  companyId: text("company_id").notNull(),
  transferNo: text("transfer_no").notNull(),
  vehicleId: text("vehicle_id")
    .notNull()
    .references(() => fleetVehicles.id),
  fromYardId: text("from_yard_id").references(() => vehicleYards.id),
  toYardId: text("to_yard_id")
    .notNull()
    .references(() => vehicleYards.id),
  transferDate: text("transfer_date").notNull(),
  reason: text("reason"),
  mileageAtTransfer: real("mileage_at_transfer"),
  status: text("status", {
    enum: ["draft", "in_transit", "completed", "cancelled"],
  })
    .notNull()
    .default("draft"),
  notes: text("notes"),
  createdBy: text("created_by"),
  completedAt: text("completed_at"),
  completedBy: text("completed_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
});

export type VehicleTransfer = typeof vehicleTransfers.$inferSelect;
export type NewVehicleTransfer = typeof vehicleTransfers.$inferInsert;
